import {createContext} from "react";

const DashboardItemContext = createContext();

export default DashboardItemContext;
